// extracted by mini-css-extract-plugin
export default {"row":"styles_row__7S+Fb","icon":"styles_icon__adr7B"};